
export default function ReportBoard({ title, subTitle, amount, context="" }) {
  return (
    <section>
      <div
        className="w-[22.82608696%] min-w-[210px] w-auto min-h-[80px] h-auto
                  bg-white border border-[1px] border-[#E9EBEF] rounded-[12px] px-[28px] py-[13px]
                  "
      >
        <h1 className="pb-[6px] text-[#696969] text-[14px] font-medium leading-[21px]">
          <span className={`${(context === 'sales' && ['vat', 'sd', 'sc'].includes(title.toLowerCase()) ? 'uppercase': 'capitalize')}`}>{title}</span> { title.toLowerCase() === 'vat' ? "" : title.toLowerCase() === 'sd' ? "" : "" }
        </h1>
        <p className="font-bold text-black leading-[30px] text-left text-[20px]">
          {Number(amount).toLocaleString('en-US')} {context === "sales" ? "TK" : ""}
        </p>
      </div>
    </section>
  );
}
